/* ENGORI — Farbwechsel und Kartenbild
   ---------------------------------------------------------------------------
   Ein gemeinsamer Code fuer:
   - den Farbwechsler "Deine Farbe ist dabei" (EngoriFarbwechsel.starten),
   - die Komponente snippets/engori-kartenbild.liquid ([data-eng-kb]) auf den
     Startseiten-Kacheln und den Produktkarten im Katalog.

   Regeln:
   - Gleicher Takt, Start je Karte um einen Bruchteil versetzt.
   - Weitere Farben laden erst, wenn die Karte sichtbar ist; ausserhalb des
     Viewports und bei verstecktem Tab ruht der Wechsel.
   - prefers-reduced-motion: kein automatischer Wechsel.
   - Hover-Buehne (drei Freisteller) nur mit Maus bzw. Tastaturfokus, erst dann
     geladen. Hover haelt den Wechsel an, danach geht es mit derselben Farbe weiter.
   - Nachgeladene Karten (Filter, Sortierung) werden automatisch erfasst.
*/
(function () {
  'use strict';
  if (window.EngoriFarbwechsel) return;

  function passt(q) { return !!(window.matchMedia && window.matchMedia(q).matches); }
  var RUHE = passt('(prefers-reduced-motion: reduce)');
  var HOVER = passt('(hover: hover) and (pointer: fine)');
  var alle = [];

  var beobachter = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) {
          var s = e.target.__engFw;
          if (!s) return;
          s.sichtbar = e.isIntersecting;
          if (s.sichtbar) { s.start(); } else { s.stopp(); }
        });
      }, { threshold: 0.25 })
    : null;

  document.addEventListener('visibilitychange', function () {
    alle.forEach(function (s) { if (document.hidden) { s.stopp(); } else { s.start(); } });
  });

  function listeAus(el) {
    var l = (el.getAttribute('data-quellen') || '').split('|').filter(Boolean);
    return l.filter(function (u, i) { return l.indexOf(u) === i; });
  }

  function steuerung(ziel, ebenen, liste, o) {
    var s = { sichtbar: !beobachter, pausiert: false };
    var TAKT = o.takt || 3000;
    var AKTIV = o.aktiv || 'is-an';
    var pos = o.pos || 0;
    var vorn = 0, angefangen = false, laeuft = null, verzug = null;

    function weiter() {
      if (!document.documentElement.contains(ziel)) { s.stopp(); return; }
      var ziel_pos = (pos + 1) % liste.length;
      var hinten = ebenen[1 - vorn];
      hinten.removeAttribute('srcset');
      hinten.removeAttribute('sizes');
      hinten.onload = function () {
        /* Kam die Pause, waehrend das Bild noch lud, bleibt die gezeigte
           Farbe stehen; beim Weiterlaufen wird dieselbe Farbe erneut geholt. */
        if (s.pausiert || (!laeuft && !verzug)) return;
        pos = ziel_pos;
        hinten.classList.add(AKTIV);
        ebenen[vorn].classList.remove(AKTIV);
        vorn = 1 - vorn;
      };
      hinten.src = liste[ziel_pos];
    }

    s.start = function () {
      if (RUHE || laeuft || verzug || s.pausiert || !s.sichtbar || document.hidden) return;
      if (!angefangen) {
        angefangen = true;
        if (o.mischen) {
          ebenen[0].removeAttribute('srcset');
          ebenen[0].src = liste[pos];
          ebenen[0].classList.add(AKTIV);
        }
      }
      verzug = setTimeout(function () {
        verzug = null;
        laeuft = setInterval(weiter, TAKT);
      }, o.versatz || 0);
    };
    s.stopp = function () {
      clearTimeout(verzug); verzug = null;
      clearInterval(laeuft); laeuft = null;
    };

    ziel.__engFw = s;
    alle.push(s);
    if (beobachter) { beobachter.observe(ziel); } else { s.start(); }
    return s;
  }

  function pauseBinden(karte, s, beimBetreten) {
    if (HOVER) {
      karte.addEventListener('pointerenter', function () {
        if (beimBetreten) beimBetreten();
        if (s) { s.pausiert = true; s.stopp(); }
      });
      karte.addEventListener('pointerleave', function () {
        if (s) { s.pausiert = false; s.start(); }
      });
      karte.addEventListener('focusin', function () {
        if (beimBetreten) beimBetreten();
        if (s) { s.pausiert = true; s.stopp(); }
      });
      karte.addEventListener('focusout', function (e) {
        if (e.relatedTarget && karte.contains(e.relatedTarget)) return;
        if (s) { s.pausiert = false; s.start(); }
      });
    }
  }

  /* Hover-Buehne: Freisteller erst beim ersten Hover laden, sichtbar erst,
     wenn alle geladen sind. */
  function hoverLaden(el) {
    var buehne = el.querySelector('.eng-kb__buehne');
    if (!buehne || buehne.hasAttribute('data-geladen')) return;
    buehne.setAttribute('data-geladen', '1');
    var bilder = buehne.querySelectorAll('img[data-src]');
    var offen = bilder.length;
    function fertig() { offen--; if (offen <= 0) buehne.classList.add('is-bereit'); }
    Array.prototype.forEach.call(bilder, function (bild) {
      bild.addEventListener('load', fertig, { once: true });
      bild.addEventListener('error', fertig, { once: true });
      if (bild.getAttribute('data-srcset')) bild.srcset = bild.getAttribute('data-srcset');
      bild.src = bild.getAttribute('data-src');
    });
  }

  /* Farbwechsler mit eigenem Markup */
  function starten(wurzel, o) {
    if (!wurzel || !o) return;
    var karten = wurzel.querySelectorAll(o.karte);
    var n = karten.length || 1;
    Array.prototype.forEach.call(karten, function (karte, nr) {
      var liste = listeAus(karte);
      var ebenen = karte.querySelectorAll(o.bild);
      if (liste.length < 2 || ebenen.length < 2) return;
      var pos = 0;
      if (o.mischen) {
        for (var i = liste.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var t = liste[i]; liste[i] = liste[j]; liste[j] = t;
        }
        pos = nr % liste.length;
      }
      var s = steuerung(karte, ebenen, liste, {
        takt: o.takt, mischen: o.mischen, pos: pos, versatz: Math.round(nr * (o.takt || 3000) / n)
      });
      if (o.pauseBeiHover) pauseBinden(karte, s);
    });
  }

  /* Komponente engori-kartenbild */
  var zaehler = 0;
  function komponenten(wurzel) {
    (wurzel || document).querySelectorAll('[data-eng-kb]:not([data-eng-kb-an])').forEach(function (el) {
      el.setAttribute('data-eng-kb-an', '1');
      var karte = el.closest('[data-eng-kb-karte]') || el;
      var nr = zaehler++;
      var liste = listeAus(el);
      var ebenen = el.querySelectorAll('.eng-kb__farbe');
      var takt = parseInt(el.getAttribute('data-takt'), 10) || 3000;
      var s = null;
      if (liste.length > 1 && ebenen.length > 1) {
        s = steuerung(el, ebenen, liste, { takt: takt, pos: 0, versatz: Math.round((nr % 4) * takt / 4) });
      }
      pauseBinden(karte, s, function () { hoverLaden(el); });
    });
  }

  /* 25.09.2026 (CODE-07): nur reagieren, wenn eine neue Karte ([data-eng-kb])
     dazukommt. Vorher lief die Suche bei jeder DOM-Änderung, auf /cart durch
     den Countdown jede Sekunde. */
  function bringtKarte(n) {
    if (n.nodeType !== 1) return false;
    return n.matches('[data-eng-kb]') || !!n.querySelector('[data-eng-kb]');
  }

  function init() {
    komponenten(document);
    var warte;
    new MutationObserver(function (aenderungen) {
      for (var i = 0; i < aenderungen.length; i++) {
        var neu = aenderungen[i].addedNodes;
        for (var j = 0; j < neu.length; j++) {
          if (bringtKarte(neu[j])) {
            clearTimeout(warte);
            warte = setTimeout(function () { komponenten(document); }, 200);
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.EngoriFarbwechsel = { starten: starten, komponenten: komponenten };
})();
